import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/GlobalStyles';

const HomeContainer = styled.div`
  width: 100%;
  height: calc(100vh - 80px);
  padding: ${theme.spacing.lg};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.md};
    height: calc(100vh - 60px);
  }
`;

const ComingSoonContainer = styled.div`
  text-align: center;
  max-width: 500px;
  padding: 40px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #f0f1f3;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 24px;
    border-radius: 12px;
    margin: 0 16px;
  }
`;

const ComingSoonTitle = styled.h1`
  color: ${theme.colors.primary};
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 16px;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 2rem;
    margin-bottom: 12px;
  }
`;

const ComingSoonSubtitle = styled.h2`
  color: #5f6368;
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 24px;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 1rem;
    margin-bottom: 20px;
  }
`;

const ComingSoonDescription = styled.p`
  color: #666;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 32px;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 0.9rem;
    margin-bottom: 24px;
  }
`;

const FeatureList = styled.ul`
  text-align: left;
  color: #666;
  font-size: 0.95rem;
  line-height: 1.8;
  margin: 0;
  padding-left: 20px;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 0.85rem;
    padding-left: 16px;
  }
`;

const FeatureItem = styled.li`
  margin-bottom: 8px;
  
  &::marker {
    color: ${theme.colors.primary};
  }
`;

const Home: React.FC = () => {
  return (
    <HomeContainer>
      <ComingSoonContainer>
        <ComingSoonTitle>Coming Soon</ComingSoonTitle>
        <ComingSoonSubtitle>Personal Dashboard</ComingSoonSubtitle>
        <ComingSoonDescription>
          Your personalised management dashboard is being crafted with care. 
          This will be your central hub for managing daily life with busy minds, providing insights, 
          quick access to tools, and a clear overview of your progress.
        </ComingSoonDescription>
        
        <FeatureList>
          <FeatureItem>Daily overview with energy levels and mood tracking</FeatureItem>
          <FeatureItem>Quick access to your most important tasks</FeatureItem>
          <FeatureItem>Personalised insights and recommendations</FeatureItem>
          <FeatureItem>Progress visualization and achievement tracking</FeatureItem>
          <FeatureItem>Customisable widgets for your specific needs</FeatureItem>
          <FeatureItem>Integration with all your productivity management tools</FeatureItem>
        </FeatureList>
      </ComingSoonContainer>
    </HomeContainer>
  );
};

export default Home; 